import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    AddressLine1: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
        ]
    },
    City: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
        ]
    },
    State: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
        ]
    },
    Postal: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
            { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
        ]
      },
      telNumber: {
        validations: [
          { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
        ]
    },
    Reference: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
        ]
      },
      theme: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
        ]
      },
      eventDate: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
          { type: 'dateinfuture', message: 'Event date must be in the future' }
        ]
      },
      plannedguestcount: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
        ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Address:*',
            mapping: 'AddressLine1'
        }
    ]
    },
    {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'City:*',
            mapping: 'City'
        }
    ]
    },
    {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:*',
            options: [
                { label: 'AL', value: 'AL' },
                { label: 'AK', value: 'AK' },
                { label: 'AZ', value: 'AZ' },
                { label: 'AR', value: 'AR' },
                { label: 'CA', value: 'CA' },
                { label: 'CO', value: 'CO' },
                { label: 'CT', value: 'CT' },
                { label: 'DE', value: 'DE' },
                { label: 'DC', value: 'DC' },
                { label: 'FL', value: 'FL' },
                { label: 'GA', value: 'GA' },
                { label: 'HI', value: 'HI' },
                { label: 'ID', value: 'ID' },
                { label: 'IL', value: 'IL' },
                { label: 'IN', value: 'IN' },
                { label: 'IA', value: 'IA' },
                { label: 'KS', value: 'KS' },
                { label: 'KY', value: 'KY' },
                { label: 'LA', value: 'LA' },
                { label: 'ME', value: 'ME' },
                { label: 'MD', value: 'MD' },
                { label: 'MA', value: 'MA' },
                { label: 'MI', value: 'MI' },
                { label: 'MN', value: 'MN' },
                { label: 'MS', value: 'MS' },
                { label: 'MO', value: 'MO' },
                { label: 'MT', value: 'MT' },
                { label: 'NE', value: 'NE' },
                { label: 'NV', value: 'NV' },
                { label: 'NH', value: 'NH' },
                { label: 'NJ', value: 'NJ' },
                { label: 'NM', value: 'NM' },
                { label: 'NY', value: 'NY' },
                { label: 'NC', value: 'NC' },
                { label: 'ND', value: 'ND' },
                { label: 'OH', value: 'OH' },
                { label: 'OK', value: 'OK' },
                { label: 'OR', value: 'OR' },
                { label: 'PA', value: 'PA' },
                { label: 'RI', value: 'RI' },
                { label: 'SC', value: 'SC' },
                { label: 'SD', value: 'SD' },
                { label: 'TN', value: 'TN' },
                { label: 'TX', value: 'TX' },
                { label: 'UT', value: 'UT' },
                { label: 'VT', value: 'VT' },
                { label: 'VA', value: 'VA' },
                { label: 'WA', value: 'WA' },
                { label: 'WV', value: 'WV' },
                { label: 'WI', value: 'WI' },
                { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
        }
    ]
    },
    {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Zip:*',
            mapping: 'Postal'
        }
    ]
    },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'How Did You Hear About Us?:*',
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Type of Event:*',
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
          type: 'text',
          size: 'Medium',
          label: 'Number of Guests:*',
          mapping: 'plannedguestcount'
        }
      ]
    },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:*',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Crane Club Contact Form',
    formId: '1854',
    clientKey: '40367709-3830-49FB-97C4-FE1D8A32979F',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
